"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFilename = void 0;
var getFilename = exports.getFilename = function getFilename(str) {
  var parts = str.split('.');
  var extension = parts[parts.length - 1].toLowerCase();
  var name = parts.slice(0, -1).join('_').replace(/[^\w_\-\s]+/g, '').replace(/^\W+/, '').replace(/\W+$/, '').replace(/\W+/g, '_').replace(/_+/g, '_').toLowerCase();
  return name + '.' + extension;
};